module.exports = __webpack_public_path__ + "assets/images/campaign-placeholder.288bae29.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/campaign-placeholder.svg
// module id = 74
// module chunks = 1612